import { useEffect, useState } from "react";
// REDUX
import { useGetBankQuery } from "../../redux/banks/bankAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { BankInterface } from "../../interfaces/Bank.interface";
// CONSTANTS
import { BLANK_BANK } from "../../constants/bank";

export default function useGetOneBank({ id = "--" }: { id: string }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [bank, setBank] = useState<BankInterface>({ ...BLANK_BANK });
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetBankQuery(
		{ token, bankId: id },
		{ skip: !token, refetchOnMountOrArgChange: false } // if token exists, launch
	);

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setBank(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		bank,
		isLoadingGetOneBank: isLoading || isFetching,
		errorMessageGetOneBank: errorMessage,
		isErrorGetOneBank: isError,
	};
}
